<template>
  <div>
    <card>
      <div slot="header">
        <l-button type="info" @click="handlenew()">新增</l-button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column label="ID">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.id}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="name" label="群組名稱" />
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs"
                  @click="handleEdit(props.row)"
                  v-show="props.row.id !== 1" >
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs"
                  @click="deleteUserGroup(props.row.id)"
                  v-show="props.row.id !== 1" >
                  <i class="fa fa-close" />
                </a>
              </div>
            </el-table-column>
          </el-table>
          <div class="col-md-3">
            <el-dialog
              center
              :title="getTitle()"
              :visible.sync="modals.custom">
              <fg-input label="群組名稱"
                        type="text"
                        name="name"
                        data-vv-as="群組名稱"
                        v-model="form.name"
                        :error="getError('name')"
                        v-validate="modelValidations.name"
                        required />
              <label>權限設定</label>
              <l-checkbox>倉儲</l-checkbox>
              <l-checkbox>行銷</l-checkbox>
              <l-checkbox>訂單</l-checkbox>
              <l-checkbox>會計</l-checkbox>
              <div class="text-right">
                <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox
    },
    data() {
      return {
        form: {
          id: 0,
          name: '',
          permission:[]
        },
        modals: {
          basic: false,
          centered: false,
          custom: false,
          confirm: false
        },
        modelValidations: {
          name: {
            required: true,
          }
        },
        tableData: []
      }
    },
   async mounted() {
      await this.getData()
    },
    methods: {
      getTitle() {
        return (parseInt(this.form.id) == 0)?'新增群組':"編輯群組"
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.errors.clear();
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (parseInt(this.form.id) == 0) {
            _this.createUserGroup()
          } else {
            _this.updateUserGroups()
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = 0
          _this.form.name = ''
          resolve()
        })
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name
        this.openModal('custom')
      },
      handleDelete(index, row) {
        alert(`Your want to delete ${row.name}`)
      },
      async getData() {
        var data = await lib.getUserGroups()
        if (data.status == 0) {
          var result = data.result
          this.tableData = result.userGroups
        }
      },
      async updateUserGroups(id) {
        var data = await lib.updateUserGroups(this.form.id, this.form.name);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        } 
      },
      async createUserGroup() {
        var data = await lib.createUserGroups(this.form.name);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } 
      },
      async deleteUserGroup(id) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteUserGroups(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else if (data.status == 106) {
            this.$swal('這群組還有使用者', '', 'error')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>
